import React, { HTMLAttributes, JSXElementConstructor, ReactNode } from 'react';
import './Row.css';

export interface IRowProps extends HTMLAttributes<any> {
	as?: string | JSXElementConstructor<any>;
	xs?: number;
	sm?: number;
	md?: number;
	lg?: number;
	align?: 'center' | 'end' | 'start' | undefined;
	justify?: 'center' | 'end' | 'start' | undefined;
    children?: string | null | ReactNode;
    className?: string;
}

const Row = ({
	className = '',
	as = 'div',
	children,
	xs,
	sm,
	md,
	lg,
	align,
	justify,
	...rest
}: IRowProps) => {
	const As: IRowProps['as'] = as;
	const breakPoints = {
		xs,
		sm,
		md,
		lg,
	};
	const getClassNames = () => {
		let classNames = '';
		for (let i = 0; i <= 3; i++) {
			if (
				Object.values(breakPoints)[i] &&
				typeof Object.values(breakPoints)[i] === 'number'
			) {
				if (Object.keys(breakPoints)[i] === 'xs') {
					classNames += ` ROW-COLS-${Object.values(breakPoints)[i]}`;
				} else {
					classNames += ` ROW-COLS-${Object.keys(breakPoints)[
						i
					].toLocaleUpperCase()}-${Object.values(breakPoints)[i]}`;
				}
			}
		}

		return classNames;
	};

	return (
		<As
			className={`Row ${align ? `Row__align--${align}` : ''}  ${
				justify ? `Row__justify--${justify}` : ''
			} ${className} ${getClassNames()}`}
			{...rest}
		>
			{children}
		</As>
	);
};

export default Row;
